import React, { useContext } from 'react'
import { IoChevronForward } from 'react-icons/io5';
import { VscDashboard } from "react-icons/vsc";
import { FiBox, FiUser } from "react-icons/fi";
import { IoReceiptOutline } from "react-icons/io5";
import { CgCreditCard } from "react-icons/cg";
import { GoPlus } from "react-icons/go";
import { AppContextProvider } from '../../App';

export const AuthorSidebar = ({ setShowCurrentTab, currentColor, currentTab }) => {
  const { showMobileAuthorMenu} = useContext(AppContextProvider)
  return (
    <div className={showMobileAuthorMenu ? "absolute top-[70px] left-0 dark:bg-[#1c1c1c] bg-white w-full z-[6000] lg:relative lg:block lg:h-screen  dark:border-gray-800 lg:w-[280px]" : "hidden z-[6000] lg:block lg:h-screen  dark:border-gray-800 lg:w-[280px]"}>
    <ul className="flex px-4 py-10 flex-col gap-8">
      <li
        onClick={() => setShowCurrentTab(1)}
        className={
          currentTab === 1
            ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2 justify-between min-w-[220px]`
            : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
        }
      >
        <div className="flex items-center space-x-2">
          <VscDashboard className="text-2xl" />
          <p>Dashboard</p>
        </div>
        <IoChevronForward
          className={currentTab === 1 ? "flex justify-end" : "hidden"}
        />
      </li>
      <li
        onClick={() => setShowCurrentTab(2)}
        className={
          currentTab === 2
            ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2 justify-between min-w-[240px]`
            : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
        }
      >
        <div className="flex items-center space-x-2">
          <FiBox className="text-2xl" />
          <p>My Products</p>
        </div>
        <IoChevronForward
          className={currentTab === 2 ? "flex justify-end" : "hidden"}
        />
      </li>
      <li
        onClick={() => setShowCurrentTab(3)}
        className={
          currentTab === 3
            ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center justify-between space-x-2`
            : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
        }
      >
        <div className="flex items-center space-x-2">
          <IoReceiptOutline className="text-2xl" />
          <p>My Sales</p>
        </div>
        <IoChevronForward
          className={currentTab === 3 ? "flex justify-end" : "hidden"}
        />
      </li>
      <li
        onClick={() => setShowCurrentTab(4)}
        className={
          currentTab === 4
            ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2 justify-between`
            : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
        }
      >
        <div className="flex items-center space-x-2">
          <CgCreditCard className="text-2xl" />
          <p>Payouts</p>
        </div>
        <IoChevronForward
          className={currentTab === 4 ? "flex justify-end" : "hidden"}
        />
      </li>
      <li
        onClick={() => setShowCurrentTab(5)}
        className={
          currentTab === 5
            ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2 justify-between`
            : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
        }
      >
        <div className="flex items-center space-x-2">
          <FiUser className="text-2xl" />
          <p>Author Profile</p>
        </div>
        <IoChevronForward
          className={currentTab === 5 ? "flex justify-end" : "hidden"}
        />
      </li>
      <li
        onClick={() => setShowCurrentTab(6)}
        className={
          currentTab === 6
              ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2 justify-between`
            : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
        } 
      >
        <div className="flex items-center space-x-2">
          <GoPlus className="text-2xl" />
          <p>New Product</p>
        </div>
        <IoChevronForward
          className={currentTab === 6 ? "flex justify-end" : "hidden"}
        />
      </li>
      <li
        onClick={() => setShowCurrentTab(7)}
        className={
          currentTab === 7
              ? `${currentColor} cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2 justify-between`
            : ` cursor-pointer rounded-xl px-3 py-3 flex items-center space-x-2`
        } 
      >
        <div className="flex items-center space-x-2">
          <CgCreditCard className="text-2xl" />
          <p>Billing Details</p>
        </div>
        <IoChevronForward
          className={currentTab === 7 ? "flex justify-end" : "hidden"}
        />
      </li>
    
    </ul>
  </div>
  )
}
